import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { MessagesService } from '@services/messages.service';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WaitModalComponent } from '@shared/modals/wait-modal/wait-modal.component';
import { ErrorInt } from '../interfaces';
import { AmKeyboardService } from '@components/am-keyboard/am-keyboard.service';
import { TimerEnum } from '@app/enums/timer.enum';
export type TimerInactive = 'xxs' | 'xs' | 'ch' | 'md' | 'gd' | 'xl' | 'xxl' | 'xxxl' | 'initial';
@Directive({
  selector: '[appAmInactive]',
  standalone: false,
})
export class AmInactiveDirective implements OnDestroy {
  seconds = 0;
  interval = 0;
  idInterval;
  timer = 15;
  subscribeReference: Subscription;

  @Input() set appAmInactive(timerEnum: TimerInactive) {
    let seconds = 0;
    timerEnum ??= 'ch';

    if (timerEnum) {
      seconds = TimerEnum[timerEnum.toLocaleUpperCase()];
    }

    this.interval = seconds;
    this.idInterval = setInterval(() => this.timerIncrement(), 1000);
  }
  constructor(
    private el: ElementRef,
    private messages: MessagesService,
    private modalService: NgbModal,
    private _keyboardServ: AmKeyboardService
  ) {}
  @HostListener('mousemove') onMouseMove() {
    this.seconds = 0;
  }
  @HostListener('keypress') onKeyPress() {
    this.seconds = 0;
  }

  timerIncrement() {
    if (!window.navigator.onLine) {
      this.seconds = 0;
      return;
    }
    this.seconds = this.seconds + 1;
    if (this.seconds === this.interval) {
      this._keyboardServ.destroy(true);
      this.messages.closeAll();
      const modalRef = this.modalService.open(WaitModalComponent, {
        centered: true,
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        windowClass: '',
      });
      this.subscribeReference = modalRef.closed.subscribe(
        (resp) => {},
        (error: ErrorInt) => {},
        () => {
          this.seconds = 0;
        }
      );
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.idInterval);
  }
}
